import { render } from "./RealName.vue?vue&type=template&id=751bdcbc&scoped=true"
import script from "./RealName.vue?vue&type=script&lang=js"
export * from "./RealName.vue?vue&type=script&lang=js"

import "./RealName.vue?vue&type=style&index=0&id=751bdcbc&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751bdcbc"]])

export default __exports__